export default "__VITE_ASSET__eeada6d6__"